'use client';
import { createContext } from 'react';
import { locales } from './ConstellationProvider.types.js';

const defaultLocale = "en-US";
const fallbackLocale = (locale) => !!locale && locales.includes(locale) ? locale : defaultLocale;
const Context = createContext({
    locale: fallbackLocale(),
});

export { Context, defaultLocale, fallbackLocale };
//# sourceMappingURL=ConstellationProvider.context.js.map
